var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"4"}},[_c('OnboardingAcceptingOrders')],1),_c('v-col',{attrs:{"cols":"8"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('OnboardingCompleteStoreProfile')],1),_c('v-col',{attrs:{"cols":"6"}},[_c('OnboardingCustomizeEmail')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }